import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";

const Board = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Boards/Board.vue");
const ManageUsers = () =>
  import(/* webpackChunkName: "extra" */ "@/views/ManageUsers/ManageUsers.vue");

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");

const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");

let boardsMenu = {
  path: "/board",
  component: DashboardLayout,
  name: "Boards",
  meta: {
    requires_auth: true
  },
  children: [
    {
      path: ":id",
      name: "Board",
      component: Board,
      props: true,
      meta: {
        requires_auth: true,
      }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  boardsMenu,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requires_auth: true,
          title: "Dashboard"
        }
      },
      {
        path: "manage-users",
        name: "Manage Users",
        component: ManageUsers,
        meta: {
          requires_auth: true,
          admin: true,
          title: "Manage Users"
        }
      }
    ]
  },
  authPages,
  { path: "*", component: Login }
];

export default routes;
